export enum AccountType {
  Customer = 'Customer',
  POC = 'POC',
  Inactive = 'Inactive',
  SI = 'SI',
  Free = 'Free',
  Internal = 'Internal',
}
